// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_HZrwJ4BxxvwqRtFD2smkSD63j9Qm" as const;
export const builtAt = "2026-11-05T15:56:44.617Z" as const;
export const vercelEnv: string | null = "production";
export const gitCommitSha: string | null = "d0924d1442e71b795aa26b70a6ca8b7bf543e8a6";
export const deploymentId: string | null = "dpl_HZrwJ4BxxvwqRtFD2smkSD63j9Qm";
